import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import Spinner from 'react-spinner-material';

export class spinner extends Component {
    render() {
        const {loading}=this.props;
        return (
            <Container>
                <Row>
                    <Col></Col>
                    <Col><Spinner radius={150} color={"#4CA7FD"}  stroke={20} visible={loading} /></Col>
                    <Col></Col>
                </Row>
            </Container> 
        )
    }
}

export default spinner
